import { Opportunity, BlogPost } from '@/types';

export const mockOpportunities: Opportunity[] = [
  {
    id: '1',
    title: 'Développeur Web Junior',
    company: 'Tech Congo',
    type: 'emploi',
    contractType: 'cdi',
    location: 'Brazzaville',
    arrondissement: 'Poto-Poto',
    description: 'Nous recherchons un développeur web junior passionné pour rejoindre notre équipe dynamique.',
    responsibilities: [
      'Développer des applications web modernes',
      'Collaborer avec l\'équipe design',
      'Maintenir et améliorer le code existant'
    ],
    requirements: [
      'Connaissance de HTML, CSS, JavaScript',
      'Esprit d\'équipe',
      'Motivation et envie d\'apprendre'
    ],
    salary: '300 000 - 500 000 FCFA',
    deadline: new Date('2024-03-15'),
    publishedAt: new Date('2024-02-01'),
    featured: true,
    phoneNumber: '+242 06 854 6715'
  },
  {
    id: '2',
    title: 'Stage Assistant Marketing Digital',
    company: 'Brazza Digital',
    type: 'stage',
    contractType: 'temps-plein',
    location: 'Brazzaville',
    arrondissement: 'Bacongo',
    description: 'Stage de 6 mois dans une agence de marketing digital en pleine croissance.',
    requirements: [
      'Étudiant en marketing ou communication',
      'Intérêt pour le digital',
      'Bonne expression écrite'
    ],
    deadline: new Date('2024-03-20'),
    publishedAt: new Date('2024-02-05'),
    featured: true,
    phoneNumber: '+242 05 523 8901'
  },
  {
    id: '3',
    title: 'Bourse d\'études - Master en Gestion',
    company: 'Université Marien Ngouabi',
    type: 'bourse',
    location: 'Brazzaville',
    description: 'Bourse complète pour un Master en Gestion des Entreprises.',
    requirements: [
      'Licence avec mention',
      'Âge maximum 25 ans',
      'Dossier de candidature complet'
    ],
    deadline: new Date('2024-04-01'),
    publishedAt: new Date('2024-02-03'),
    featured: false
  },
  {
    id: '4',
    title: 'Formation Entrepreneuriat Jeunesse',
    company: 'Impact Hub Brazzaville',
    type: 'formation',
    location: 'Brazzaville',
    arrondissement: 'Makélékélé',
    description: 'Programme intensif de 3 mois pour jeunes entrepreneurs.',
    requirements: [
      'Projet entrepreneurial défini',
      'Disponibilité à temps plein',
      'Âge 18-30 ans'
    ],
    deadline: new Date('2024-03-10'),
    publishedAt: new Date('2024-02-07'),
    featured: true,
    phoneNumber: '+242 06 445 2367'
  },
  {
    id: '5',
    title: 'Volontaire Éducation Environnementale',
    company: 'Green Congo',
    type: 'volontariat',
    location: 'Brazzaville',
    arrondissement: 'Talangaï',
    description: 'Mission de volontariat pour sensibiliser les jeunes à l\'environnement.',
    requirements: [
      'Passion pour l\'environnement',
      'Capacité d\'animation',
      'Engagement de 6 mois minimum'
    ],
    deadline: new Date('2024-03-25'),
    publishedAt: new Date('2024-02-08'),
    featured: false
  },
  {
    id: '6',
    title: 'Commercial Terrain',
    company: 'Congo Telecom',
    type: 'emploi',
    contractType: 'cdd',
    location: 'Brazzaville',
    arrondissement: 'Ouenzé',
    description: 'Poste de commercial terrain pour développer notre réseau de distribution.',
    salary: '250 000 - 400 000 FCFA',
    deadline: new Date('2024-03-18'),
    publishedAt: new Date('2024-02-06'),
    featured: false,
    phoneNumber: '+242 06 789 1234'
  }
];

export const mockBlogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Stratégies Optimales pour Réussir son Entretien d\'Embauche',
    excerpt: 'Une analyse approfondie des méthodologies de présentation professionnelle pour maximiser vos chances de succès lors des entretiens d\'embauche.',
    content: 'Guide complet des stratégies d\'entretien...',
    category: 'preparation-entretiens',
    publishedAt: new Date('2025-02-01'),
    author: 'Prince Amani',
    slug: 'strategies-reussir-entretien-embauche',
    coverImage: 'blog-entretien-hero'
  },
  {
    id: '2',
    title: 'Comment rédiger un CV percutant',
    excerpt: 'Découvrez les meilleures pratiques pour créer un CV qui retient l\'attention des recruteurs à Brazzaville.',
    content: 'Article complet sur la rédaction de CV...',
    category: 'conseils-cv',
    publishedAt: new Date('2024-02-01'),
    author: 'Ahmad Rufai Mohammed',
    slug: 'comment-rediger-cv-percutant-2024'
  },
  {
    id: '3',
    title: 'Les 10 questions d\'entretien les plus fréquentes',
    excerpt: 'Préparez-vous efficacement aux questions classiques que les recruteurs posent lors des entretiens d\'embauche.',
    content: 'Guide complet de préparation aux entretiens...',
    category: 'preparation-entretiens',
    publishedAt: new Date('2025-02-03'),
    author: 'Dhruv KUMAR',
    slug: 'questions-entretien-frequentes',
    coverImage: 'blog-questions-hero'
  },
  {
    id: '4',
    title: 'L\'IA comme Voie de Développement à Brazzaville',
    excerpt: 'Découvrez comment l\'intelligence artificielle transforme Brazzaville et ouvre de nouvelles perspectives de développement économique et social.',
    content: 'Article complet sur l\'IA à Brazzaville...',
    category: 'innovation-tech',
    publishedAt: new Date('2025-02-10'),
    author: 'Kendra Nkoum',
    slug: 'ia-developpement-brazzaville',
    coverImage: 'blog-ai-hero'
  }
];

export const arrondissements = [
  'Makélékélé',
  'Bacongo',
  'Poto-Poto',
  'Moungali',
  'Ouenzé',
  'Talangaï',
  'Mfilou',
  'Madibou',
  'Djiri'
];